// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3fV4U","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ic-B"};